import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import { NOTIFICATION_TYPES, showNotification } from '@/views/components/Modals/notification';

import { getErrorMessageFromAPI } from '../../utilz';
import { setAppLoader } from '../common/CommonActions';
import {
  addRoutingGuideCarrierError,
  createRoutingGuideInSuccess,
  createRoutingGuideUserInSuccess,
  deleteRoutingGuidesInError,
  deleteRoutingGuidesInSuccess,
  deleteRoutingUserInFail,
  deleteRoutingUserInSuccess,
  editRoutingGuideCarrierError,
  getAllUsersNameForGuidesSuccess,
  getContentNXPRoutingGuideInError,
  getContentNXPRoutingGuideInSuccess,
  getNXPUserSearchInInFail,
  getNXPUserSearchInInSuccess,
  getRoutingGuideCarriersError,
  getRoutingGuideCarriersSuccess,
  getRoutingGuideCollaboratorsSuccess,
  getRoutingGuidelist,
  getRoutingGuidelistReset,
  routingGuideSuccess,
  setRoutingSpotFilterData,
  updateContentNXPRoutingGuideInError,
  updateContentNXPRoutingGuideInSuccess,
} from './RoutingGuideAction';
import {
  addRoutingGuideCarrierEffect,
  addRoutingGuideCollaboratorEffect,
  createRoutingGuideEffect,
  createRoutingGuideUserEffect,
  deleteRoutingGuideCarrierEffect,
  deleteRoutingGuideCollaboratorEffect,
  deleteRoutingGuidesEffect,
  deleteRoutingUserEffect,
  editRoutingGuideCarrierEffect,
  editRoutingGuideCollaboratorEffect,
  getAllUsersNameEffect,
  getContentNXPRoutingGuideEffect,
  getFilteredGuidesEffect,
  getNXPUserSearchListEffect,
  getRoutingGuideCarriersEffect,
  getRoutingGuideCollaboratorsEffect,
  getRoutingGuideVal,
  updateContentNXPRoutingGuideEffect,
} from './RoutingGuideEffects';
import RoutingGuideTypes from './RoutingGuideTypes';

//TODO: Remove after endpoint is deployed
const mockedResponse = {
  data: {
    routingGuides: [
      {
        carriers: [
          {
            email: null,
            id: 19,
            scac: 'DHLC',
            shortName: 'DHLC    ',
            status: 'active',
            transportationProvider: 'DHL EXPRESS U S A INCORPORATED',
          },
        ],
        collaborators: [
          {
            emails: null,
            group: 'User',
            id: 6,
            name: null,
            notificationsEnabled: true,
            role: 'Administrator',
            userId: 15851,
          },
        ],
        routingHeader: {
          country: 'UNITED STATES',
          id: 6,
          modifiedBy: null,
          modifiedOn: null,
          name: 'DevRoutingGuide',
          transportationGroup: 'EXPL',
          transportationMode: 'AIR',
        },
      },
    ],
  },
};
function* getRoutingGuideValue() {
  try {
    const { routingGuideDetails } = yield select((state) => state.routingGuide);
    const { data } = yield call(getRoutingGuideVal, routingGuideDetails.req);
    yield put(routingGuideSuccess({ data }));
  } catch {}
}

function* createRoutingGuide({ payload: { ...payload } }) {
  yield put(setAppLoader(true));

  try {
    const { data } = yield call(createRoutingGuideEffect, payload);
    yield put(createRoutingGuideInSuccess({ data }));
    yield put(setAppLoader(false));
    yield call(showNotification, {
      message: payload?.routingKey > 0 ? 'Successfully Updated' : 'Successfully Created.',
      type: NOTIFICATION_TYPES.SUCCESS,
    });
  } catch (e) {
    yield put(
      deleteRoutingGuidesInError({
        message: getErrorMessageFromAPI(e),
      }),
    );
    yield put(setAppLoader(false));
    yield call(showNotification, {
      message: payload?.routingKey > 0 ? 'Failed to Update' : 'Failed to Create.',
      type: NOTIFICATION_TYPES.ERROR,
    });
  }
}

function* createRoutingGuideUser({ payload: { ...payload } }) {
  yield put(setAppLoader(true));

  try {
    const { data } = yield call(createRoutingGuideUserEffect, payload);
    yield put(createRoutingGuideUserInSuccess({ data }));
    yield put(setAppLoader(false));
    yield call(showNotification, {
      message: payload?.userId > 0 ? 'Successfully Updated' : 'Successfully Created.',
      type: NOTIFICATION_TYPES.SUCCESS,
    });
  } catch {
    yield put(setAppLoader(false));
    yield call(showNotification, {
      message: payload?.userId > 0 ? 'Failed to Update' : 'Failed to Create.',
      type: NOTIFICATION_TYPES.ERROR,
    });
  }
}

function* deleteRoutingGuides({ payload }) {
  const { routingGuideDetails } = yield select((state) => state.routingGuide);
  try {
    const { data } = yield call(deleteRoutingGuidesEffect, payload);
    yield put(
      deleteRoutingGuidesInSuccess({
        data,
      }),
    );
    yield put(setAppLoader(false));
    yield call(showNotification, {
      message: 'Successfully Deleted.',
      type: NOTIFICATION_TYPES.SUCCESS,
    });
    // yield put(setShipmentList({ data: [], progressing: true }));
    yield put(getRoutingGuidelistReset());
    yield put(getRoutingGuidelist({ ...routingGuideDetails?.req }));
  } catch (e) {
    yield put(
      deleteRoutingGuidesInError({
        message: getErrorMessageFromAPI(e),
      }),
    );
    yield put(setAppLoader(false));
    yield call(showNotification, {
      message: 'Failed',
      type: NOTIFICATION_TYPES.SUCCESS,
    });
  }
}

function* getContentNXPRoutingGuideApi() {
  yield put(setAppLoader(true));
  try {
    const { data } = yield call(getContentNXPRoutingGuideEffect);
    yield put(
      getContentNXPRoutingGuideInSuccess({
        data,
      }),
    );
    yield put(setAppLoader(false));
  } catch (e) {
    yield put(
      getContentNXPRoutingGuideInError({
        message: getErrorMessageFromAPI(e),
      }),
    );
    yield put(setAppLoader(false));
  }
}

function* updateContentNXPRoutingGuideApi({ payload }) {
  yield put(setAppLoader(true));
  try {
    const { data } = yield call(updateContentNXPRoutingGuideEffect, payload);
    yield put(
      updateContentNXPRoutingGuideInSuccess({
        data,
      }),
    );
    yield put(setAppLoader(false));
    if (data?.status === 'save') {
      yield call(showNotification, {
        message: 'Updated successfully.',
        type: NOTIFICATION_TYPES.SUCCESS,
      });
    } else {
      yield call(showNotification, {
        message: 'Failed',
        type: NOTIFICATION_TYPES.ERROR,
      });
    }
  } catch (e) {
    yield put(
      updateContentNXPRoutingGuideInError({
        message: getErrorMessageFromAPI(e),
      }),
    );
    yield put(setAppLoader(false));
    yield call(showNotification, {
      message: 'Failed',
      type: NOTIFICATION_TYPES.ERROR,
    });
  }
}

function* getNXPUserSearchListAPI() {
  const { nxpUserSearchList } = yield select((state) => state.routingGuide);
  try {
    const { data } = yield call(getNXPUserSearchListEffect, nxpUserSearchList.request);
    yield put(
      getNXPUserSearchInInSuccess({
        data,
      }),
    );
  } catch (e) {
    yield put(
      getNXPUserSearchInInFail({
        message: getErrorMessageFromAPI(e),
      }),
    );
  }
}

function* deleteRoutingUserApi({ payload }) {
  yield put(setAppLoader(true));
  try {
    const { data } = yield call(deleteRoutingUserEffect, payload);
    yield put(
      deleteRoutingUserInSuccess({
        data,
      }),
    );
    yield call(showNotification, {
      message: 'Successfully Deleted.',
      type: NOTIFICATION_TYPES.SUCCESS,
    });
    yield put(setAppLoader(false));
  } catch (e) {
    yield call(showNotification, {
      message: 'Failed',
      type: NOTIFICATION_TYPES.ERROR,
    });
    yield put(setAppLoader(false));
    yield put(
      deleteRoutingUserInFail({
        message: getErrorMessageFromAPI(e),
      }),
    );
  }
}

function* getFilteredGuides() {
  const filterParams = yield select((state) => state.routingGuide.guidesListSearchParams);
  const castedParams = filterParams.reduce((acc, item) => {
    acc[item.type] = item.value;
    return acc;
  }, {});

  try {
    yield put(setRoutingSpotFilterData({ isLoading: true }));
    const { data } = yield call(getFilteredGuidesEffect, castedParams);
    yield put(setRoutingSpotFilterData({ ...data, isLoading: false }));
  } catch {
    yield put(setRoutingSpotFilterData({ ...mockedResponse.data, isLoading: false }));
  }
}

function* getRoutingGuidesCarriers({ payload }) {
  try {
    yield put(setAppLoader(true));

    const { data } = yield call(getRoutingGuideCarriersEffect, payload);
    yield put(getRoutingGuideCarriersSuccess({ data }));
  } catch (e) {
    const errorMsg = getErrorMessageFromAPI(e, 'Failed to get carrier details');
    yield put(
      getRoutingGuideCarriersError({
        message: errorMsg,
      }),
    );
    yield call(showNotification, {
      message: errorMsg,
      type: NOTIFICATION_TYPES.ERROR,
    });
  } finally {
    yield put(setAppLoader(false));
  }
}

function* getRoutingGuidesCollaborators({ payload }) {
  try {
    yield put(setAppLoader(true));

    const { data } = yield call(getRoutingGuideCollaboratorsEffect, payload);
    yield put(getRoutingGuideCollaboratorsSuccess({ data }));
  } catch (e) {
    const errorMsg = getErrorMessageFromAPI(e, 'Failed to get collaborators');

    yield put(
      getRoutingGuideCarriersError({
        message: errorMsg,
      }),
    );

    yield call(showNotification, {
      message: errorMsg,
      type: NOTIFICATION_TYPES.ERROR,
    });
  } finally {
    yield put(setAppLoader(false));
  }
}

function* getAllUsersNameForGuides({ payload }) {
  try {
    yield put(setAppLoader(true));

    const { data } = yield call(getAllUsersNameEffect, payload);
    yield put(getAllUsersNameForGuidesSuccess({ data }));
  } catch (e) {
    const errorMsg = getErrorMessageFromAPI(e, 'Failed to get all users names for guides');

    yield put(
      getRoutingGuideCarriersError({
        message: errorMsg,
      }),
    );

    yield call(showNotification, {
      message: errorMsg,
      type: NOTIFICATION_TYPES.ERROR,
    });
  } finally {
    yield put(setAppLoader(false));
  }
}

function* addRoutingGuideCarrier({ payload }) {
  try {
    yield put(setAppLoader(true));

    yield call(addRoutingGuideCarrierEffect, payload);
    const { data } = yield call(getRoutingGuideCarriersEffect, {
      routingGuideId: payload.routingGuideId,
    });
    yield put(getRoutingGuideCarriersSuccess({ data }));
    yield call(showNotification, {
      message: 'Routing Guide was successfully Updated',
      type: NOTIFICATION_TYPES.SUCCESS,
    });
  } catch (e) {
    const errorMsg = getErrorMessageFromAPI(e, 'Failed to add carrier');

    addRoutingGuideCarrierError({
      message: errorMsg,
    });

    yield call(showNotification, {
      message: errorMsg,
      type: NOTIFICATION_TYPES.ERROR,
    });
  } finally {
    yield put(setAppLoader(false));
  }
}

function* addRoutingGuideCollaborator({ payload }) {
  try {
    yield put(setAppLoader(true));
    if (Array.isArray(payload.collaborator)) {
      yield all(
        payload.collaborator.map((item) =>
          call(addRoutingGuideCollaboratorEffect, {
            collaborator: item,
            routingGuideId: payload.routingGuideId,
          }),
        ),
      );
    } else {
      yield call(addRoutingGuideCollaboratorEffect, payload);
    }
    const { data } = yield call(getRoutingGuideCollaboratorsEffect, {
      routingGuideId: payload.routingGuideId,
    });
    yield put(getRoutingGuideCollaboratorsSuccess({ data }));

    yield call(showNotification, {
      message: 'Routing Guide was successfully Updated',
      type: NOTIFICATION_TYPES.SUCCESS,
    });
  } catch (e) {
    const errorMsg = getErrorMessageFromAPI(e, 'Failed to add collaborator');

    yield call(showNotification, {
      message: errorMsg,
      type: NOTIFICATION_TYPES.ERROR,
    });
  } finally {
    yield put(setAppLoader(false));
  }
}

function* deleteRoutingGuideCarrier({ payload }) {
  try {
    yield put(setAppLoader(true));

    yield call(deleteRoutingGuideCarrierEffect, payload);
    const { data } = yield call(getRoutingGuideCarriersEffect, {
      routingGuideId: payload.routingGuideId,
    });
    yield put(getRoutingGuideCarriersSuccess({ data }));
  } catch (e) {
    const errorMsg = getErrorMessageFromAPI(e, 'Failed to delete carrier');

    addRoutingGuideCarrierError({
      message: errorMsg,
    });

    yield call(showNotification, {
      message: errorMsg,
      type: NOTIFICATION_TYPES.ERROR,
    });
  } finally {
    yield put(setAppLoader(false));
  }
}

function* deleteRoutingGuideCollaborator({ payload }) {
  try {
    yield put(setAppLoader(true));

    yield call(deleteRoutingGuideCollaboratorEffect, payload);
    const { data } = yield call(getRoutingGuideCollaboratorsEffect, {
      routingGuideId: payload.routingGuideId,
    });
    yield put(getRoutingGuideCollaboratorsSuccess({ data }));
  } catch (e) {
    const errorMsg = getErrorMessageFromAPI(e, 'Failed to delete carrier');

    addRoutingGuideCarrierError({
      message: errorMsg,
    });

    yield call(showNotification, {
      message: errorMsg,
      type: NOTIFICATION_TYPES.ERROR,
    });
  } finally {
    yield put(setAppLoader(false));
  }
}

function* editRoutingGuideCarrier({ payload }) {
  try {
    yield put(setAppLoader(true));

    yield call(editRoutingGuideCarrierEffect, payload);

    const { data } = yield call(getRoutingGuideCarriersEffect, {
      routingGuideId: payload.routingGuideId,
    });
    yield put(getRoutingGuideCarriersSuccess({ data }));
  } catch (e) {
    const errorMsg = getErrorMessageFromAPI(e, 'Failed to edit carrier');

    yield put(
      editRoutingGuideCarrierError({
        message: errorMsg,
      }),
    );
    yield call(showNotification, {
      message: errorMsg,
      type: NOTIFICATION_TYPES.ERROR,
    });
  } finally {
    yield put(setAppLoader(false));
  }
}

function* editRoutingGuideCollaborators({ payload }) {
  try {
    yield put(setAppLoader(true));

    yield call(editRoutingGuideCollaboratorEffect, payload);

    const { data } = yield call(getRoutingGuideCollaboratorsEffect, {
      routingGuideId: payload.routingGuideId,
    });
    yield put(getRoutingGuideCollaboratorsSuccess({ data }));
  } catch (e) {
    const errorMsg = getErrorMessageFromAPI(e, 'Failed to edit collaborator');
    yield call(showNotification, {
      message: errorMsg,
      type: NOTIFICATION_TYPES.ERROR,
    });
  } finally {
    yield put(setAppLoader(false));
  }
}

export default function* routguideSaga() {
  yield takeLatest(RoutingGuideTypes.GET_ROUTING_GUIDE_LIST, getRoutingGuideValue);
  yield takeLatest(RoutingGuideTypes.CREATE_ROUTING_GUIDE_PROGRESS, createRoutingGuide);
  yield takeLatest(RoutingGuideTypes.CREATE_ROUTING_GUIDE_USER_PROGRESS, createRoutingGuideUser);

  yield takeLatest(RoutingGuideTypes.DELETE_ROUTING_GUIDES_PROGRESS, deleteRoutingGuides);

  yield takeLatest(RoutingGuideTypes.GET_CONTENT_NXP_ROUTING_GUIDE, getContentNXPRoutingGuideApi);

  yield takeLatest(RoutingGuideTypes.UPDATE_CONTENT_NXP_ROUTING_GUIDE, updateContentNXPRoutingGuideApi);

  yield takeLatest(RoutingGuideTypes.GET_NXP_USER_SEARCH_INPROGRESS, getNXPUserSearchListAPI);

  yield takeLatest(RoutingGuideTypes.DELETE_NXP_USER, deleteRoutingUserApi);

  yield takeLatest(RoutingGuideTypes.GET_FILTERED_GUIDE_LIST, getFilteredGuides);

  yield takeLatest(RoutingGuideTypes.GET_CARRIERS_ROUTING_GUIDE_PROGRESS, getRoutingGuidesCarriers);

  yield takeLatest(RoutingGuideTypes.GET_COLLABORATORS_ROUTING_GUIDE_PROGRESS, getRoutingGuidesCollaborators);

  yield takeLatest(RoutingGuideTypes.GET_ALL_USERS_NAME_PROGRESS, getAllUsersNameForGuides);

  yield takeLatest(RoutingGuideTypes.ADD_ROUTING_GUIDE_CARRIER_PROGRESS, addRoutingGuideCarrier);

  yield takeLatest(RoutingGuideTypes.ADD_ROUTING_GUIDE_COLLABORATORS_PROGRESS, addRoutingGuideCollaborator);

  yield takeLatest(RoutingGuideTypes.DELETE_ROUTING_GUIDE_CARRIER_PROGRESS, deleteRoutingGuideCarrier);

  yield takeLatest(RoutingGuideTypes.DELETE_ROUTING_GUIDE_COLLABORATOR_PROGRESS, deleteRoutingGuideCollaborator);

  yield takeLatest(RoutingGuideTypes.EDIT_CARRIER_ROUTING_GUIDE_PROGRESS, editRoutingGuideCarrier);

  yield takeLatest(RoutingGuideTypes.EDIT_COLLABORATORS_ROUTING_GUIDE_PROGRESS, editRoutingGuideCollaborators);
}
